import React from 'react';
import { Skeleton } from 'antd';
import { Users, UserCheck, UserX } from 'lucide-react';
import { StatCard } from '../../../common';
import { formatNumber } from '../../../../utils/format';
import { t } from '../../../../company/labels';

function AnalyticsStats({ totalPromotors, activePromotors, inactiveCount, period, loading }) {
    const periodLabel = period === 'day' ? 'hoy' : period === 'week' ? 'esta semana' : 'este mes';

    const stats = [
        {
            title: `Total ${t('promotores')}`,
            value: totalPromotors,
            icon: <Users />,
            tone: 'brand'
        },
        {
            title: `Activos ${periodLabel}`,
            value: activePromotors,
            icon: <UserCheck />,
            tone: 'success'
        },
        {
            title: `Sin actividad ${periodLabel}`,
            value: inactiveCount,
            icon: <UserX />,
            tone: 'danger'
        }
    ];

    if (loading) {
        return (
            <div className="grid gap-4 grid-cols-1 md:grid-cols-3">
                {[1, 2, 3].map((i) => (
                    <div key={i} className="stat-card">
                        <Skeleton active title={{ width: '50%' }} paragraph={{ rows: 1, width: '30%' }} />
                    </div>
                ))}
            </div>
        );
    }

    return (
        <div className="grid gap-4 grid-cols-1 md:grid-cols-3">
            {stats.map((stat) => (
                <StatCard key={stat.tone} label={stat.title} value={formatNumber(stat.value)} icon={stat.icon} tone={stat.tone} />
            ))}
        </div>
    );
}

export default AnalyticsStats;
